
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 19.286v-5.007c0-.35.375-.707.75-.707l2.5-.007c.375 0 .75.357.75.714v5c0 .19.079.37.22.505a.77.77 0 00.53.209l6.5.007a.77.77 0 00.53-.21.697.697 0 00.22-.504v-9.4c0-.558-.234-1.089-.645-1.468-1.762-1.624-6.669-6.155-8.824-8.208A.754.754 0 0010 0a.783.783 0 00-.531.21C7.46 2.123 2.431 6.77.643 8.42.233 8.799 0 9.328 0 9.886v9.4c0 .19.079.37.22.505A.77.77 0 00.75 20h6.5a.77.77 0 00.53-.21.697.697 0 00.22-.504z"}})])
          )
        }
      }
    